import { PERIODS } from 'constants/calendar';
import {
    CHANGE_CALENDAR_PERIOD,
    CHANGE_CALENDAR_TASK_VIEW
} from 'constants/actionTypes.js';

const initialState = {
    period: PERIODS.DAY,
    showCompletedTasks: false
};

export const calendarReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_CALENDAR_PERIOD:
            return {
                ...state,
                period: action.payload.period
            }
        case CHANGE_CALENDAR_TASK_VIEW:
            return {
                ...state,
                showCompletedTasks: action.payload.showCompletedTasks
            }
        default:
            return state;
    }
};
